import { FC, useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Checkbox } from "../../Elements/Checkbox";
import { IApprovalConsentFields } from "../../types/IBase";

export type IApprovalConsents = Required<IApprovalConsentFields>;

export const getInitialApprovalConsents = (
  authorityConsentFromBackend?: boolean | null
): IApprovalConsents => ({
  authorityCollectsAndProcessesPersonalDataConsent:
    authorityConsentFromBackend !== false,
  selfCollectsPersonalDataConsent: false,
});

export const useApprovalConsents = (
  authorityConsentFromBackend?: boolean | null
) => {
  const [consents, setConsents] = useState<IApprovalConsents>(() =>
    getInitialApprovalConsents(authorityConsentFromBackend)
  );

  const resetConsents = useCallback(() => {
    setConsents(getInitialApprovalConsents(authorityConsentFromBackend));
  }, [authorityConsentFromBackend]);

  useEffect(() => {
    setConsents((prev) => ({
      ...prev,
      authorityCollectsAndProcessesPersonalDataConsent:
        authorityConsentFromBackend !== false,
    }));
  }, [authorityConsentFromBackend]);

  return {
    consents,
    setConsents,
    resetConsents,
  };
};

interface Props {
  consents: IApprovalConsents;
  onChange: (consents: IApprovalConsents) => void;
  className?: string;
}

export const ApprovalConsentCheckboxes: FC<Props> = ({
  consents,
  onChange,
  className,
}) => {
  const { t } = useTranslation();

  return (
    <div className={className || "flex column gap-2 mt-3"}>
      <Checkbox
        className="statement"
        label={t("ApprovalConsentOrgan")}
        selected={consents.authorityCollectsAndProcessesPersonalDataConsent}
        setSelected={(authorityCollectsAndProcessesPersonalDataConsent) =>
          onChange({
            ...consents,
            authorityCollectsAndProcessesPersonalDataConsent,
          })
        }
      />
      <Checkbox
        className="statement"
        label={t("ApprovalConsentPersonalData")}
        selected={consents.selfCollectsPersonalDataConsent}
        setSelected={(selfCollectsPersonalDataConsent) =>
          onChange({
            ...consents,
            selfCollectsPersonalDataConsent,
          })
        }
      />
    </div>
  );
};
